var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree"},[_c('Tree',{attrs:{"data":_vm.treeData,"load-data":_vm.loadData},on:{"on-select-change":_vm.handleTree}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }